/**
 * "Framework support" — CLI section (ADR-0074).
 * Reconciled from packages/cli/src/detect + docs/architecture/framework-support.md.
 * Framed honestly: broad auto-detection, with import / custom-endpoint fallbacks.
 */
import type { DocPageContent } from '../types';

export const CLI_FRAMEWORKS_PAGE: DocPageContent = {
  slug: 'cli/frameworks',
  titleKey: 'docs.cli.frameworks.title',
  descriptionKey: 'docs.cli.frameworks.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.cli.frameworks.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'languages',
      textKey: 'docs.cli.frameworks.languages.heading',
    },
    {
      kind: 'list',
      itemKeys: [
        'docs.cli.frameworks.lang.js',
        'docs.cli.frameworks.lang.python',
        'docs.cli.frameworks.lang.ruby',
        'docs.cli.frameworks.lang.php',
        'docs.cli.frameworks.lang.go',
        'docs.cli.frameworks.lang.rust',
        'docs.cli.frameworks.lang.jvm',
        'docs.cli.frameworks.lang.csharp',
        'docs.cli.frameworks.lang.elixir',
        'docs.cli.frameworks.lang.more',
      ],
    },

    // The frontend leg had no documentation at all, which left the docs saying
    // discovery reads "your routes" — true of a backend and false of the
    // customer this feature exists for: the one whose API is in another
    // repository, behind a third-party service, or absent.
    { kind: 'heading', level: 2, id: 'frontend', textKey: 'docs.cli.frameworks.frontend.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.frameworks.frontend.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.cli.frameworks.frontend.item.http',
        'docs.cli.frameworks.frontend.item.typed',
        'docs.cli.frameworks.frontend.item.realtime',
      ],
    },
    { kind: 'code', language: 'bash', code: 'npx syncanix init --surface frontend' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.cli.frameworks.frontend.note.title',
      textKey: 'docs.cli.frameworks.frontend.note.body',
    },

    { kind: 'heading', level: 2, id: 'override', textKey: 'docs.cli.frameworks.override.heading' },
    { kind: 'paragraph', textKey: 'docs.cli.frameworks.override.body' },

    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.cli.frameworks.accuracy.title',
      textKey: 'docs.cli.frameworks.accuracy.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.cli.frameworks.next.init.title',
          textKey: 'docs.cli.frameworks.next.init.text',
          to: { docSlug: 'cli/init' },
        },
        {
          titleKey: 'docs.cli.frameworks.next.commands.title',
          textKey: 'docs.cli.frameworks.next.commands.text',
          to: { docSlug: 'cli/commands' },
        },
      ],
    },
  ],
};
